import styled from "styled-components";

import CreditCardInput from "shared/components/atoms/CreditCardInput";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;

  width: 100%;

  grid-area: number;
`;

export const Label = styled.label`
  width: 100%;
  margin: 0 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const Required = styled.span`
  font-family: Inter;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;

export interface IInputProps {
  error: boolean;
}

export const Input = styled(CreditCardInput)<IInputProps>`
  display: flex;
  align-items: center;

  width: 100%;
  height: 3rem;
  padding: 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  border-radius: 0.5rem;
  border: 0.094rem solid
    ${(props) =>
      props.error
        ? props.theme?.checkoutStepsOffers?.red
        : props.theme?.checkoutStepsOffers?.inputBorderColor};
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};

  position: relative;

  &[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  &::placeholder {
    color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
  }

  &:disabled {
    opacity: 0.8;
  }

  &:hover {
    border: 0.094rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a0`};
  }

  &:focus {
    border: 0.094rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a8`};
  }
`;

export const InvalidMessage = styled.span`
  width: 100%;
  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;
